import PostBase from './postbase'
import Category from './category'
export default class Post extends PostBase{
    imageUrl:string;
    imageId:number;
    minImageUrl:string;
    minImageId:number;
    categories: Array<Category>;
    authors: Array<Category>;
    order:number;

    constructor() {
        super();
        this.imageUrl= "";
        this.imageId=0;
        this.minImageUrl= "";
        this.minImageId=0;
        this.authors =[];
        this.order = 0;
  	}
}